import type { CategoryDto } from "../../shared/CategoryDto";
import type { IAccessTokenProvider } from "../../application/interfaces/IAccessTokenProvider";
import type { ICategoryRepository } from "../../application/interfaces/ICategoryRepository";
import type { IAppConfigProvider } from "../../application/interfaces/IAppConfigProvider";

export class CategoryRepository implements ICategoryRepository {
  readonly configProvider: IAppConfigProvider;
  readonly tokenProvider: IAccessTokenProvider;

  datastore:CategoryDto[]|null = null

  constructor(
    configProvider: IAppConfigProvider,
    tokenProvider: IAccessTokenProvider,
  ) {
    this.configProvider = configProvider;
    this.tokenProvider = tokenProvider;
  }

  async getById(id: number): Promise<CategoryDto> {
    const token = await this.tokenProvider.getAccessToken();
    const config = await this.configProvider.getAppConfig();
    const headers: Record<string, string> = {
      "X-Api-Key": config.apiKey,
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    const url = `${config.apiUrl}/CourseCategory/${id}`;
    const response = await fetch(url, {
      headers,
    });
    if (response.ok) {
      return (await response.json()) as CategoryDto;
    } else {
      throw new Error(
        `Failed to fetch sender: HTTP ${response.status} ${response.statusText}`,
      );
    }
  }

  async getAll(): Promise<CategoryDto[]> {
    if (this.datastore != null){
      return this.datastore
    }
    const token = await this.tokenProvider.getAccessToken();
    const config = await this.configProvider.getAppConfig();
    const headers: Record<string, string> = {
      "X-Api-Key": config.apiKey,
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    const url = `${config.apiUrl}/CourseCategory?isPublished=true`;
    const response = await fetch(url, {
      headers,
    });
    if (response.ok) {
      let result = (await response.json()) as CategoryDto[];
      let sorted =  result.sort((a, b) => a.courseCategoryId - b.courseCategoryId)
      this.datastore = sorted
      return this.datastore;
    }
      throw new Error(
        `Failed to fetch sender: HTTP ${response.status} ${response.statusText}`,
      );
  }

  
}
